<script lang="ts">
    import {_} from 'svelte-i18n'
    import {newConversations, paths} from './services';
    import PulseButton from './PulseButton.svelte';
</script>


{#if $newConversations.size > 0}
    <a href={$paths.home}>
        {$_('user.session.XNewClients', {values: {x: $newConversations.size}})}
    </a>
    <PulseButton title={$_('commons.OkITakeNote')} on:click={() => newConversations.snoozeAll()}>OK</PulseButton>
{/if}